import { useCallback, useMemo } from 'react';
import uuid from 'react-uuid';
import Button from 'src/components/design-system/Button';
import useViewDepartment from 'src/hooks/useViewDepartments';
import { DepartmentGlCode, DepartmentMembers } from 'src/types/department';

const AddNewDepartment = () => {
  const { setDepartmentTableData, setIsEditMode, departmentTableData, t, setSelectedRows } =
    useViewDepartment();

  const handleAddDepartment = useCallback(() => {
    setSelectedRows([]);
    const newData = {
      id: Math.random(),
      rowId: uuid(),
      name: '',
      departmentId: 0,
      glCodes: [] as DepartmentGlCode[],
      members: [] as DepartmentMembers[],
      selected: false,
      isNewDepartmentName: true,
    };
    setTimeout(() => {
      setDepartmentTableData((prev) => [newData, ...prev]);
    }, 100);
    setIsEditMode(true);
  }, [setDepartmentTableData, setIsEditMode, setSelectedRows]);

  const isAddNewDepartmentBtnDisabled = useMemo(
    () => departmentTableData.some((department) => department.isNewDepartmentName === true),
    [departmentTableData]
  );
  return (
    <Button onClick={handleAddDepartment} color="primary" disabled={isAddNewDepartmentBtnDisabled}>
      {t('Add New Department')}
    </Button>
  );
};

export default AddNewDepartment;
